import { Component, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

import { NewWorkflowRequestDialogComponent } from '../new-workflow-request-dialog/new-workflow-request-dialog.component';

/**
 * Dedicated landing page for the "New Workflow Request" deep-link.
 * URL: /securehome/new-request
 *
 * Immediately redirects to the contracts list and opens the Drop and Reveal dialog.
 * Designed to be bookmarked or used as a desktop shortcut so users can go straight
 * to the AI intake modal without navigating through the app.
 */
@Component({
  selector: 'app-new-request-landing',
  standalone: true,
  imports: [MatProgressSpinnerModule],
  template: `
    <div style="display:flex;align-items:center;justify-content:center;height:80vh;flex-direction:column;gap:16px;">
      <mat-spinner diameter="48"></mat-spinner>
      <p style="color:#666;font-size:0.95rem;">Opening intake...</p>
    </div>
  `
})
export class NewRequestLandingComponent implements OnInit {
  private router = inject(Router);
  private dialog = inject(MatDialog);

  ngOnInit(): void {
    // Navigate to contracts list as the background page, then open the dialog.
    this.router.navigate(['/securehome/contracts'], { replaceUrl: true }).then(() => {
      // Small delay to let the list view render before the dialog opens on top
      setTimeout(() => {
        this.dialog.open(NewWorkflowRequestDialogComponent, {
          width: '640px',
          maxWidth: '92vw',
          autoFocus: false,
          restoreFocus: false
        });
      }, 300);
    });
  }
}
